
export default class Newsletter {
    
	constructor() {
        
        this.form = document.getElementById('newsletter-form')
        this.messageContainer = document.getElementById('newsletter-form__message')
        this.submitButton = document.getElementById('newsletter-form__submit-button')
        
        this.handleSubmit = this.handleSubmit.bind(this);
        this.submitForm = this.submitForm.bind(this);

	}
    
    async submitForm( formData ) {
        
        // Headers not set as workaround for empty $_POST object in Craft
        // https://stackoverflow.com/questions/71387088/empty-request-request-and-request-files-with-multipart-form-data/71392989#71392989
        return await fetch('/mailchimp/send', {
            method: 'post',
            mode: 'cors',
            body: formData,
        })
        
    }
    
    handleSubmit( e ) {
        
        e.preventDefault();
        
        // Get values from form
        let formData = new FormData( this.form )
        
        // Look for redirect URL in form values
        let redirectUrl = null
        for ( let [ key, value ] of formData ) {
            if ( key === 'redirect' ) {
                redirectUrl = value
            }
        }
        
        // Set form loading status
        // TODO - disable form while processing
        this.messageContainer.innerHTML = null
        this.submitButton.innerHTML = 'Behandler'
        
        this.submitForm( formData )
            .then(res => res.json())
            .then(jsonResponse => {
                if ( jsonResponse.success ) {
                    this.submitButton.innerHTML = 'Takk!'
                    if ( redirectUrl ) {
                        window.location.href = redirectUrl
                    } else {
                        this.messageContainer.innerHTML = 'Takk for din påmelding. Vi har sendt deg en epost for å fullføre påmeldingen.'
                    }
                } else {
                    this.submitButton.innerHTML = 'Send inn'
                    if ( jsonResponse.msg ) {
                        this.messageContainer.innerHTML = jsonResponse.msg
                    } else {
                        this.messageContainer.innerHTML = 'Noe gikk galt. Vennligst prøv igjen senere.'
                    }
                }
            })
            .catch(err => {
                console.warn('err: ', err)
                this.messageContainer.innerHTML = 'Noe gikk galt. Vennligst prøv igjen senere.'
                this.submitButton.innerHTML = 'Send inn'
            })
        
        
    }

	init() {
        
        if ( this.form ) {
            this.form.addEventListener('submit', this.handleSubmit)
        }

	}

}
